import React from "react";
import { Component } from "react";
import "./css/home.css";
import Aboutme from "./Aboutme";
import Landing from "./landing";

class Home extends Component {


    state = {  } 

    

    render() { 
        return (
            <React.Fragment>
                <div className="home-feat" id="home">
                    
                    <Landing />
                    <Aboutme />
                </div>
            </React.Fragment>
        );
    }
}
 
export default Home;
